import * as REDUX_TYPES from '../types'

const INITIAL_STATE = {
    emailConfirmation: false, //Set in EMailConfirmation to flag SignInComponent
    ethAccount: undefined, //Public key for Ethereum account
    isArtist: false, //True if the signed-in User has created at least one Message
    signedIn: false,
    studios: [],
    subscribedStudios: []
}

const accountReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case REDUX_TYPES.ACCOUNT.EMAIL_CONFIRMATION:
            return {
                ...state,
                emailConfirmation: action.emailConfirmation,
            }
        case REDUX_TYPES.ACCOUNT.ETH:
            return {
                ...state,
                ethAccount: action.ethAccount,
            }            
        case REDUX_TYPES.ACCOUNT.IS_ARTIST:
            return {
                ...state,
                isArtist: action.isArtist,
            }
        case REDUX_TYPES.ACCOUNT.SIGNED_IN:
            return {
                ...state,
                signedIn: action.signedIn,
            }
        case REDUX_TYPES.ACCOUNT.STUDIOS:
            return {
                ...state,
                studios: action.studios,
            }
        case REDUX_TYPES.ACCOUNT.SUBSCRIBED_STUDIOS:
            return {
                ...state,
                subscribedStudios: action.subscribedStudios,
            }
        case REDUX_TYPES.ACCOUNT.RESET:
            return INITIAL_STATE
        default:
            return state
    }
}
export default accountReducer